import ContentCard from 'scripts/models/api/cards/base/contentCard';

export default  ContentCard.extend({
    define: {
        streamId: {
            type: 'string',
            value: null
        }
    }
});